import { useTranslation } from "react-i18next";

import RoutPath from "../RoutPath";
import { Container } from "react-bootstrap";

import emptyCart from "../../assets/svg-icons/empty-cart.svg";

const EmptyCart = () => {
    const [t] = useTranslation("global");
    return (
        <section className="cart-section ocean-section">
            <Container>
                <RoutPath />
                <div className="empty-cart">
                    <img src={emptyCart} alt="empty cart" />
                    <h1 className="card-list-header">{t("cart.empty-cart")}</h1>
                    <p className="ocean-p">{t("cart.add-something")}</p>
                    <button className="ocean-btn">
                        <span>{t("cart.keep-shopping")}</span>
                    </button>
                </div>
            </Container>
        </section>
    );
};

export default EmptyCart;
